import { Box, Flex } from '@chakra-ui/react';

type PhoneFrameProps = {
  children: React.ReactNode;
};

/** Coded device frame - no image asset. Renders app-like screen content inside. */
export const PhoneFrame = ({ children }: PhoneFrameProps) => (
  <Box
    position="relative"
    w="252px"
    h="512px"
    borderRadius="42px"
    p="9px"
    background="linear-gradient(160deg, hsl(228, 11.6%, 19%) 0%, hsl(228, 11.6%, 9%) 100%)"
    border="1px solid"
    borderColor="whiteAlpha.200"
    style={{
      // Тень только тёмная: цветной ореол вокруг корпуса делал из макета светящийся объект,
      // хотя показать надо экран, а не устройство.
      boxShadow: '0 34px 80px -24px rgba(0,0,0,0.8), inset 0 1px 0 0 rgba(255,255,255,0.06)',
    }}
  >
    <Flex
      direction="column"
      position="relative"
      w="100%"
      h="100%"
      borderRadius="34px"
      overflow="hidden"
      background="hsl(228, 11.6%, 7%)"
      border="1px solid"
      borderColor="whiteAlpha.100"
      textAlign="left"
    >
      {/* notch */}
      <Box
        position="absolute"
        top="9px"
        left="50%"
        transform="translateX(-50%)"
        w="86px"
        h="20px"
        borderRadius="full"
        bg="black"
        zIndex={6}
      />
      {children}
    </Flex>
  </Box>
);
